import { render, staticRenderFns } from "./ResultNotFound.vue?vue&type=template&id=5f0ed871&scoped=true"
import script from "./ResultNotFound.vue?vue&type=script&lang=js"
export * from "./ResultNotFound.vue?vue&type=script&lang=js"
import style0 from "./ResultNotFound.vue?vue&type=style&index=0&id=5f0ed871&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ed871",
  null
  
)

export default component.exports